import React from 'react'
import styled from 'styled-components'
import theme from '../styles/theme'

const AttributesContainer = styled.div`
  background: ${theme.color.background.light};
  padding: 2rem;
  border-radius: 8px;
  box-shadow: inset 0 2px 4px ${theme.color.shadow.light};
`

const AttributesGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1rem;
`

const AttributeField = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

const Label = styled.label`
  font-size: 1.2rem;
  font-weight: 600;
  color: ${theme.color.text.grey};
  text-transform: uppercase;
  letter-spacing: 0.05em;
`

const Value = styled.div`
  font-size: 1.4rem;
  color: ${theme.color.text.base};
  font-weight: 500;
`

const StatusBadge = styled.div<{ status: any }>`
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  background: ${props => {
    const statusStr = String(props.status).toLowerCase();
    return statusStr === 'active' || statusStr === 'true' ? '#e6ffe6' :
           statusStr === 'inactive' || statusStr === 'false' ? '#ffe6e6' :
           theme.color.background.lightGrey
  }};
  color: ${props => {
    const statusStr = String(props.status).toLowerCase();
    return statusStr === 'active' || statusStr === 'true' ? '#007700' :
           statusStr === 'inactive' || statusStr === 'false' ? '#d70036' :
           theme.color.text.base
  }};
  font-size: 1.2rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  display: inline-block;
  width: fit-content;
`

const OptInBadge = styled.div<{ optIn: boolean }>`
  padding: 0.25rem 0.75rem;
  border-radius: 20px;
  background: ${props => props.optIn ? '#e6ffe6' : '#ffe6e6'};
  color: ${props => props.optIn ? '#007700' : '#d70036'};
  font-size: 1.2rem;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  display: inline-block;
  width: fit-content;
`

const Title = styled.h2`
  font-size: 2.4rem;
  font-weight: 700;
  color: ${theme.color.text.base};
  margin-bottom: 2rem;
`

interface CustomAttributesProps {
  userData: any
}

const CustomAttributes: React.FC<CustomAttributesProps> = ({ userData }) => {
  if (!userData || !userData.user) {
    return null
  }

  const user = userData.user
  const userProfile = user.user_profile || {}

  const getAttribute = (key: string) => {
    return userProfile[key] || 'N/A'
  }

  const formatBoolean = (value: any) => {
    if (value === true || value === 'true' || value === '1') return true
    if (value === false || value === 'false' || value === '0') return false
    return null
  }

  const marketingOptIn = formatBoolean(getAttribute('marketing_opt_in'))

  return (
    <AttributesContainer>
      <Title>Custom Profile Attributes</Title>
      <AttributesGrid>
        <AttributeField>
          <Label>Loyalty Status</Label>
          <Value>
            <StatusBadge status={getAttribute('loyalty_status')}>
              {getAttribute('loyalty_status') === true || getAttribute('loyalty_status') === 'true' ? 'Active' : 
               getAttribute('loyalty_status') === false || getAttribute('loyalty_status') === 'false' ? 'Inactive' : 
               String(getAttribute('loyalty_status'))}
            </StatusBadge>
          </Value>
        </AttributeField>

        <AttributeField>
          <Label>Home Studio</Label>
          <Value>{getAttribute('home_studio')}</Value>
        </AttributeField>

        <AttributeField>
          <Label>Marketing Opt In</Label>
          <Value>
            {marketingOptIn !== null ? (
              <OptInBadge optIn={marketingOptIn}>
                {marketingOptIn ? 'Opted In' : 'Opted Out'}
              </OptInBadge>
            ) : (
              'N/A'
            )}
          </Value>
        </AttributeField>

        <AttributeField>
          <Label>Top Studio</Label>
          <Value>{getAttribute('top_studio')}</Value>
        </AttributeField>

        <AttributeField>
          <Label>Favorite Shake</Label>
          <Value>{getAttribute('favoriteShake')}</Value>
        </AttributeField>

        <AttributeField>
          <Label>Top Size</Label>
          <Value>{getAttribute('topSize')}</Value>
        </AttributeField>

        <AttributeField>
          <Label>Bottom Size</Label>
          <Value>{getAttribute('bottomSize')}</Value>
        </AttributeField>

        <AttributeField>
          <Label>Shoe Size</Label>
          <Value>{getAttribute('shoeSize')}</Value>
        </AttributeField>
      </AttributesGrid>
    </AttributesContainer>
  )
}

export default CustomAttributes